




























import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'
import Vue from 'vue'
import WeirdMailing from '@/components/Newsletters/weirdMailingAlert.vue'
import Poll from '@/models/polls/Poll'
export default Vue.extend({
  props: {
    scope: {} as () => {poll: Poll},
    options: {}
  },
  components: {
    infoRowsBlock,
    WeirdMailing
  },
  methods: {
    async cancel (): Promise<void> {
      try {
        await this.$store.dispatch('polls/cancel', this.scope.poll.getId())
        await this.$store.dispatch('polls/get', this.scope.poll.getId())
        // @ts-ignore
        this.$message.success(this.$t('newsletters.canceled'))
      } catch (error) {
        // @ts-ignore
        this.$message.error(this.$t('newsletters.not_canceled'))
      }
    },
    async resend (): Promise<void> {
      try {
        await this.$store.dispatch('polls/resend', this.scope.poll.getId())
        await this.$store.dispatch('polls/get', this.scope.poll.getId())
        // @ts-ignore
        this.$message.success(this.$t('newsletters.canceled_queue'))
      } catch (error) {
        // @ts-ignore
        this.$message.error(this.$t('newsletters.not_canceled_retry'))
      }
    }
  }
})
